import { useNavigate } from "react-router-dom";
import useAuth from "../../hook/useAuth";
import useDelete from "../../hook/useDelete";
import { useState } from "react";
import { PleasewaitPopup } from "../../components/PleasewaitPopup";
import axios from "axios";
import { baseURL } from "../../config/api";
import { PhoneNumberInput } from "../../components/PhoneNumberInput";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import AddOpenHour from "./AddOpenHour";


type OpenHourType = {
    id: number;
    locationId: number;
    startDate: string;
    endDate: string;
    isSundayOpen: boolean;
    sundayOpenTime: string;
    sundayCloseTime: string;
    isMondayOpen: boolean;
    mondayOpenTime: string;
    mondayCloseTime: string;
    isTuesdayOpen: boolean;
    tuesdayOpenTime: string;
    tuesdayCloseTime: string;
    isWednesdayOpen: boolean;
    wednesdayOpenTime: string;
    wednesdayCloseTime: string;
    isThursdayOpen: boolean;
    thursdayOpenTime: string;
    thursdayCloseTime: string;
    isFridayOpen: boolean;
    fridayOpenTime: string;
    fridayCloseTime: string;
    isSaturdayOpen: boolean;
    saturdayOpenTime: string;
    saturdayCloseTime: string;
    uniqueId: number;
};

export const AddLocation = () => {
    const { auth }: any = useAuth();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const navigate = useNavigate();
    const [locationName, setLocationName] = useState<string>("");
    const [prefix, setPrefix] = useState<string>("");
    const [isAirport, setIsAirport] = useState<string>("No");
    const [emailAddress, setEmailAddress] = useState<string>("");
    const [phoneNumber, setPhoneNumber] = useState<string>("");
    const [isActive, setIsActive] = useState<string>("No");
    const [isImages, setIsImages] = useState<string>("No");
    const [supportedCurrencies, setSupportedCurrencies] = useState<string>("");
    const [country, setCountry] = useState<string>("");
    const [state, setState] = useState<string>("");
    const [city, setCity] = useState<string>("");
    const [zipCode, setZipCode] = useState<string>("");
    const [street, setStreet] = useState<string>("");
    const [street2, setStreet2] = useState<string>("");
    const [billToCountry, setBillToCountry] = useState<string>("");
    const [billToState, setBillToState] = useState<string>("");
    const [billToCity, setBillToCity] = useState<string>("");
    const [billToZipCode, setBillToZipCode] = useState<string>("");
    const [billToStreet, setBillToStreet] = useState<string>("");
    const [billToStreet2, setBillToStreet2] = useState<string>("");
    const [latitude, setLatitude] = useState<string>("");
    const [longitude, setLongitude] = useState<string>("");
    const [websiteLink, setWebsiteLink] = useState<string>("");
    const [preventBookingsInClosedHours, setPreventBookingsInClosedHours] = useState<string>("No");
    const [addOpenHour, setAddOpenHour] = useState<OpenHourType[]>([
        {
            id: 0,
            locationId: 0,
            startDate: "",
            endDate: "",
            isSundayOpen: false,
            sundayOpenTime: "",
            sundayCloseTime: "",
            isMondayOpen: false,
            mondayOpenTime: "",
            mondayCloseTime: "",
            isTuesdayOpen: false,
            tuesdayOpenTime: "",
            tuesdayCloseTime: "",
            isWednesdayOpen: false,
            wednesdayOpenTime: "",
            wednesdayCloseTime: "",
            isThursdayOpen: false,
            thursdayOpenTime: "",
            thursdayCloseTime: "",
            isFridayOpen: false,
            fridayOpenTime: "",
            fridayCloseTime: "",
            isSaturdayOpen: false,
            saturdayOpenTime: "",
            saturdayCloseTime: "",
            uniqueId: 1,
        },
    ]);
    const [uniqueNumber, setUniqueNumber] = useState<number>(2);
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        setPleaseWaitPopup(true);

        const openHourData = addOpenHour.map((item: any) => {
            return {
                startDate: item.startDate,
                endDate: item.endDate,
                isSundayOpen: item.isSundayOpen,
                sundayOpenTime: item.sundayOpenTime,
                sundayCloseTime: item.sundayCloseTime,
                isMondayOpen: item.isMondayOpen,
                mondayOpenTime: item.mondayOpenTime,
                mondayCloseTime: item.mondayCloseTime,
                isTuesdayOpen: item.isTuesdayOpen,
                tuesdayOpenTime: item.tuesdayOpenTime,
                tuesdayCloseTime: item.tuesdayCloseTime,
                isWednesdayOpen: item.isWednesdayOpen,
                wednesdayOpenTime: item.wednesdayOpenTime,
                wednesdayCloseTime: item.wednesdayCloseTime,
                isThursdayOpen: item.isThursdayOpen,
                thursdayOpenTime: item.thursdayOpenTime,
                thursdayCloseTime: item.thursdayCloseTime,
                isFridayOpen: item.isFridayOpen,
                fridayOpenTime: item.fridayOpenTime,
                fridayCloseTime: item.fridayCloseTime,
                isSaturdayOpen: item.isSaturdayOpen,
                saturdayOpenTime: item.saturdayOpenTime,
                saturdayCloseTime: item.saturdayCloseTime,
            };
        });

        await axios
            .post(
                `${baseURL}locations?userId=${auth?.id}`,
                JSON.stringify({
                    locationName,
                    prefix,
                    isAirport: isAirport === "Yes",
                    websiteLink,
                    emailAddress,
                    phoneNumber,
                    isActive: isActive === "Yes",
                    isImages: isImages === "Yes",
                    street,
                    street2,
                    city,
                    state,
                    zipCode,
                    country,
                    billToCity,
                    billToCountry,
                    billToState,
                    billToStreet,
                    billToStreet2,
                    billToZip: billToZipCode,
                    latitude,
                    longitude,
                    supportedCurrencies,
                    preventBookingsInClosedHours: preventBookingsInClosedHours === "Yes"
                }),
                {
                    headers: {
                        "Content-Type": "application/json"
                    },
                    withCredentials: false,
                }
            )
            .then(async (res) => {
                await Promise.all(
                    openHourData?.map((item: any) => {
                        return axios.post(
                            `${baseURL}locationOpenHours?userId=${auth?.id}`, {
                            ...item,
                            locationId: res?.data
                        })
                            .catch((error) => {
                                setPleaseWaitPopup(false);
                                console.error(error)
                            });
                    }));
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error(error)
            });
    };

    const addNewRow = () => {
        const addOpenHourData: OpenHourType = {
            id: 0,
            locationId: 0,
            startDate: "",
            endDate: "",
            isSundayOpen: false,
            sundayOpenTime: "",
            sundayCloseTime: "",
            isMondayOpen: false,
            mondayOpenTime: "",
            mondayCloseTime: "",
            isTuesdayOpen: false,
            tuesdayOpenTime: "",
            tuesdayCloseTime: "",
            isWednesdayOpen: false,
            wednesdayOpenTime: "",
            wednesdayCloseTime: "",
            isThursdayOpen: false,
            thursdayOpenTime: "",
            thursdayCloseTime: "",
            isFridayOpen: false,
            fridayOpenTime: "",
            fridayCloseTime: "",
            isSaturdayOpen: false,
            saturdayOpenTime: "",
            saturdayCloseTime: "",
            uniqueId: uniqueNumber,
        };

        setAddOpenHour((addOpenHour: OpenHourType[]) => [
            ...addOpenHour,
            addOpenHourData,
        ]);
        setUniqueNumber(uniqueNumber + 1);
    };

    const changeDataOnOpenHour = (data: OpenHourType, index: number) => {
        setAddOpenHour((addOpenHour) =>
            addOpenHour.map((rowValue: OpenHourType, i: number) => {
                return i === index ? data : rowValue;
            })
        );
    };

    const deleteTheFleetOpenHour = (uniqueNumber: number) => {
        setDeleteData({
            id: 0,
            tilte: `Delete`,
            summary: `Are you sure you want to delete this Open Hour?`,
            isDelete: async (callback: any) => {
                const updateData: OpenHourType[] = addOpenHour.filter(
                    (item: OpenHourType) => item.uniqueId !== uniqueNumber
                );
                setAddOpenHour(() => updateData);
                callback();
            }
        });

        setDeletePopup(true);
    };

    return (
        <>
            <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
                <div className="w-full bg-white p-4 rounded-md">
                    <h2 className={`text-lg font-semibold`}>Add Location</h2>

                    <div className="mt-2 p-2">
                        <form onSubmit={(e) => handleSubmit(e)}>
                            <div className="w-full">
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6">
                                    {/* First Column */}
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-[#667085]">Name</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={locationName}
                                                placeholder="Name"
                                                onChange={(e) => setLocationName(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-[#667085]">CC Email?</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={emailAddress}
                                                placeholder="CC Email"
                                                onChange={(e) => setEmailAddress(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>

                                    {/* Second Column */}
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-[#667085]">Prefix</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={prefix}
                                                placeholder="Prefix"
                                                onChange={(e) => setPrefix(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-[#667085]">Mobile Number</label>
                                            <PhoneNumberInput
                                                name={"phoneNumber"}
                                                value={phoneNumber}
                                                setValue={setPhoneNumber}
                                                fontSize={"14px"}
                                                required={true}
                                            />
                                        </div>

                                        <div className="w-full flex items-start justify-between mt-[20px]">
                                            <div>
                                                <label className={`block text-xs font-medium text-[#667085]`}>Is Airport?</label>
                                                <RadioGroup
                                                    row
                                                    value={isAirport}
                                                    onChange={(e) => setIsAirport(e.target.value)}
                                                >
                                                    <FormControlLabel
                                                        value="Yes"
                                                        control={
                                                            <Radio
                                                                sx={{
                                                                    color: "gray",
                                                                    "&.Mui-checked": {
                                                                        color: "blue",
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                        label="Yes"
                                                        sx={{
                                                            color: "#2f3739",
                                                        }}
                                                    />

                                                    <FormControlLabel
                                                        value="No"
                                                        control={
                                                            <Radio
                                                                sx={{
                                                                    color: "gray",
                                                                    "&.Mui-checked": {
                                                                        color: "blue",
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                        label="No"
                                                        sx={{
                                                            color: "#2f3739",
                                                        }}
                                                    />
                                                </RadioGroup>
                                            </div>

                                            <div>
                                                <label className={`block text-xs font-medium text-[#667085]`}>Active?</label>
                                                <RadioGroup
                                                    row
                                                    value={isActive}
                                                    onChange={(e) => setIsActive(e.target.value)}
                                                >
                                                    <FormControlLabel
                                                        value="Yes"
                                                        control={
                                                            <Radio
                                                                sx={{
                                                                    color: "gray",
                                                                    "&.Mui-checked": {
                                                                        color: "blue",
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                        label="Yes"
                                                        sx={{
                                                            color: "#2f3739",
                                                        }}
                                                    />

                                                    <FormControlLabel
                                                        value="No"
                                                        control={
                                                            <Radio
                                                                sx={{
                                                                    color: "gray",
                                                                    "&.Mui-checked": {
                                                                        color: "blue",
                                                                    },
                                                                }}
                                                            />
                                                        }
                                                        label="No"
                                                        sx={{
                                                            color: "#2f3739",
                                                        }}
                                                    />
                                                </RadioGroup>
                                            </div>

                                        </div>

                                        <div>
                                            <label className={`block text-xs font-medium text-[#667085]`}>Images?</label>
                                            <RadioGroup
                                                row
                                                value={isImages}
                                                onChange={(e) => setIsImages(e.target.value)}
                                            >
                                                <FormControlLabel
                                                    value="Yes"
                                                    control={
                                                        <Radio
                                                            sx={{
                                                                color: "gray",
                                                                "&.Mui-checked": {
                                                                    color: "blue",
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label="Yes"
                                                    sx={{
                                                        color: "#2f3739",
                                                    }}
                                                />

                                                <FormControlLabel
                                                    value="No"
                                                    control={
                                                        <Radio
                                                            sx={{
                                                                color: "gray",
                                                                "&.Mui-checked": {
                                                                    color: "blue",
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label="No"
                                                    sx={{
                                                        color: "#2f3739",
                                                    }}
                                                />
                                            </RadioGroup>
                                        </div>

                                    </div>
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6">

                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-[#667085]">Ship To Street1</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={street}
                                                placeholder="Ship To Street1"
                                                onChange={(e) => setStreet(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-[#667085]">Ship To State</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={state}
                                                placeholder="Ship To State"
                                                onChange={(e) => setState(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-[#667085]">Ship To Country</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={country}
                                                placeholder="Ship To Country"
                                                onChange={(e) => setCountry(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-[#667085]">Latitude</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={latitude}
                                                placeholder="Latitude"
                                                onChange={(e) => setLatitude(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-[#667085]">Bill To Street1</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={billToStreet}
                                                placeholder="Bill To Street1"
                                                onChange={(e) => setBillToStreet(e.target.value)}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-[#667085]">Bill To State</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={billToState}
                                                placeholder="Bill To State"
                                                onChange={(e) => setBillToState(e.target.value)}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-[#667085]">Bill To Country</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={billToCountry}
                                                placeholder="Bill To Country"
                                                onChange={(e) => setBillToCountry(e.target.value)}

                                            />
                                        </div>

                                    </div>

                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-[#667085]">Ship To Street2</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={street2}
                                                placeholder="Ship To Street2"
                                                onChange={(e) => setStreet2(e.target.value)}
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-medium text-[#667085]">Ship To City</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={city}
                                                placeholder="Ship To City"
                                                onChange={(e) => setCity(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-medium text-[#667085]">Ship To Zip Code</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={zipCode}
                                                placeholder="Ship To Zip Code"
                                                onChange={(e) => setZipCode(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-medium text-[#667085]">Longitude</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={longitude}
                                                placeholder="Longitude"
                                                onChange={(e) => setLongitude(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-medium text-[#667085]">Bill To Street2</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={billToStreet2}
                                                placeholder="Bill To Street2"
                                                onChange={(e) => setBillToStreet2(e.target.value)}
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-medium text-[#667085]">Bill To City</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={billToCity}
                                                placeholder="Bill To City"
                                                onChange={(e) => setBillToCity(e.target.value)}

                                            />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-medium text-[#667085]">Bill To Zip Code</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={billToZipCode}
                                                placeholder="Bill To Zip Code"
                                                onChange={(e) => setBillToZipCode(e.target.value)}

                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6">
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-[#667085]">Website Link</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={websiteLink}
                                                onChange={(e) => setWebsiteLink(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-[#667085]">Supported Currencies</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={supportedCurrencies}
                                                onChange={(e) =>
                                                    setSupportedCurrencies(e.target.value)
                                                }
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="grid grid-cols-2 gap-6 mt-2">

                                    <div className="space-y-4">
                                        <div>
                                            <label className={`block text-xs font-medium text-[#667085]`}>Prevent Bookings In Closed Hours?</label>
                                            <RadioGroup
                                                row
                                                value={preventBookingsInClosedHours}
                                                onChange={(e) => setPreventBookingsInClosedHours(e.target.value)}
                                            >
                                                <FormControlLabel
                                                    value="Yes"
                                                    control={
                                                        <Radio
                                                            sx={{
                                                                color: "gray",
                                                                "&.Mui-checked": {
                                                                    color: "blue",
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label="Yes"
                                                    sx={{
                                                        color: "#2f3739",
                                                    }}
                                                />

                                                <FormControlLabel
                                                    value="No"
                                                    control={
                                                        <Radio
                                                            sx={{
                                                                color: "gray",
                                                                "&.Mui-checked": {
                                                                    color: "blue",
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label="No"
                                                    sx={{
                                                        color: "#2f3739",
                                                    }}
                                                />
                                            </RadioGroup>
                                        </div>

                                        {
                                            addOpenHour?.map((item: OpenHourType, index: number) => {
                                                return (
                                                    <AddOpenHour
                                                        key={index}
                                                        index={index}
                                                        uniqueNumber={item.uniqueId}
                                                        data={item}
                                                        changeDataOnOpenHour={(data: OpenHourType, index: number) =>
                                                            changeDataOnOpenHour(data, index)
                                                        }
                                                        deleteTheFleetOpenHour={deleteTheFleetOpenHour}
                                                    />
                                                )
                                            })
                                        }

                                        <button
                                            onClick={() => addNewRow()}
                                            className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                        >
                                            Add New Open Hour Block
                                        </button>
                                    </div>
                                    <div className="space-y-4">
                                    </div>
                                </div>
                                {/* Buttons */}
                                <div className="flex flex-col sm:flex-row gap-4 mt-6">
                                    <button
                                        type="submit"
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                    >
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => navigate(-1)}
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-[#FFFFFF] text-primary cursor-pointer border border-primary"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>
    )
}